// API Configuration
export const API_CONFIG = {
  // Base URLs
  BASE_URL: 'https://103.165.14.167:7073/api',
  IMAGE_BASE_URL: 'https://103.165.14.167:7073',
  GEO_API_BASE_URL: 'http://103.165.14.167:7070/api',

  
  // Checkout/Order Endpoints
  ORDERS: {
    CREATE: '/orders',
    PAY: '/orders/pay',
    GET_USER_ORDERS: '/orders/user',
    MY_ORDERS: '/orders/my-orders',
    MY_ORDER_DETAILS: '/orders/my-orders', //{orderId} will be appended
    ORDER_TRACKING: '/orders/my-orders', // /{orderId}/tracking will be appended
  },
  
  // Admin Order Management Endpoints
  ADMIN_ORDERS: {
    GET_ALL: '/orders/admin/orders',
    GET_BY_ID: '/orders/admin/orders', // /{orderId} will be appended
    CANCEL: '/orders', // /{orderId}/cancel will be appended
    ADD_TRACKING: '/orders/admin', // /{orderId}/tracking will be appended
  },
  
  // Shipment Endpoints
  SHIPMENTS: {
    CREATE: '/shipments',
  },
  
  // Account/Address Endpoints
  ACCOUNT: {
    LOGIN: '/account/login',
    REGISTER: '/account/register',
    SEND_REGISTER_OTP: '/account/send-register-otp',
    VERIFY_REGISTER_OTP: '/account/verify-register-otp',
    FORGOT_PASSWORD: '/account/forgotpassword',
    RESET_PASSWORD: '/account/resetpassword',
    ADDRESSES: '/account/addresses',
    ADD_ADDRESS: '/account/addaddress',
    UPDATE_ADDRESS: '/account/updateaddress',
    DELETE_ADDRESS: '/account/address', // Singular - ID will be appended
  },
  
  // Auth Endpoints (alias for ACCOUNT for backward compatibility)
  AUTH: {
    LOGIN: '/account/login',
    REGISTER: '/account/register',
    SEND_REGISTER_OTP: '/account/send-register-otp',
    VERIFY_REGISTER_OTP: '/account/verify-register-otp',
    FORGOT_PASSWORD: '/account/forgotpassword',
    RESET_PASSWORD: '/account/resetpassword',
  },
  
  // Category Endpoints
  CATEGORIES: {
    PARENTS: '/categories/parents',
  },
  
  // Admin Category Endpoints
  ADMIN_CATEGORIES: {
    GET_ALL: '/admin/parent-categories',
    ADD: '/admin/category',
    UPDATE: '/admin/categorybyid', // /{id} will be appended
    CHANGE_STATUS: '/admin/changecategorystatus', // ?categoryId={id}&setActive={status}
  },
  
  // Admin Subcategory Endpoints
  ADMIN_SUBCATEGORIES: {
    GET_ALL: '/admin/subcategories',
    ADD: '/admin/add-sub-category',
    UPDATE: '/admin/updatesubcate', // /{id} will be appended
    CHANGE_STATUS: '/admin', // /{id}/status?isActive={status}
  },
  
  // Admin Brand Endpoints
  ADMIN_BRANDS: {
    GET_ALL: '/admin/brands', // ?page={page}&pageSize={pageSize}
    ADD: '/admin/brands',
    UPDATE: '/admin/brands', // /{id} will be appended
    DELETE: '/admin/brands', // /{id} will be appended
    CHANGE_STATUS: '/admin/brands', // /{id}/status?isActive={status}
  },
  
  // Admin Users Endpoints
  ADMIN_USERS: {
    GET_ALL: '/admin/users',
    ADD_USER: '/admin/add-user',
    TOGGLE_STATUS: '/admin/set-user-status', // /{userId} will be appended
    GET_BY_ID: '/admin/get-userprofiledetailsbyid', // /{userId} will be appended
    UPDATE_USER: '/admin/update-user-with-address', // /{userId} will be appended
  },
  
  // Admin User Roles Endpoints
  ADMIN_USER_ROLES: {
    GET_ALL: '/admin/userroles',
    ADD: '/admin/userroles',
    UPDATE: '/admin/userroles', // /{id} will be appended
    TOGGLE_ACTIVE: '/admin/userroles', // /{id}/toggle-active will be appended
  },
  
  // Admin Products Endpoints
  ADMIN_PRODUCTS: {
    GET_ALL: '/admin/products',
    GET_BY_ID: '/admin/products', // /{id} will be appended
    ADD: '/admin/products',
    UPDATE: '/admin/updateproductdetailbyproductid', // /{productId} will be appended
    UPDATE_STATUS: '/admin/update-products-status', // /{productId}?isActive={status}
  },
  
  // Admin Tax Categories Endpoints
  ADMIN_TAX_CATEGORIES: {
    GET_ALL: '/admin/taxcategories',
  },
  
  // Admin Contacts Endpoints
  ADMIN_CONTACTS: {
    GET_ALL: '/Contacts',
    SEND_EMAIL: '/Contacts', // /{id}/send-email will be appended
  },
  
  // Admin Product Enquiry Endpoints
  ADMIN_ENQUIRIES: {
    GET_ALL: '/ProductEnquiry',
    SEND_EMAIL: '/ProductEnquiry', // /{id}/send-email will be appended
  },
  
  // Admin Product Variants Endpoints
  ADMIN_PRODUCT_VARIANTS: {
    GET_BY_PRODUCT: '/admin/products-variants', // /{productId} will be appended
    ADD: '/admin/products', // /{productId}/variants will be appended
    UPDATE: '/admin/product-variants', // /{variantId} will be appended
    TOGGLE_STATUS: '/admin/product-variants', // /{variantId} will be appended
  },
  
  // Product Endpoints
  PRODUCTS: {
    BY_CATEGORY: '/products/bycategory',
    LIST: '/products',
    DETAIL: '/products/productdetails',
    RELATED: '/products/related',
    SEARCH: '/products/search',
    CREATE: '/products',
    UPDATE: '/products',
    DELETE: '/products',
  },
  
  // Product Reviews Endpoints
  REVIEWS: {
    POST: '/productreviews',
    GET_BY_PRODUCT: '/productreviews/byproduct',
    LIKE: '/productreviews',
    DISLIKE: '/productreviews',
  },
  
  // Admin Product Reviews Endpoints
  ADMIN_REVIEWS: {
    GET_ALL: '/productreviews',
    GET_BY_PRODUCT: '/productreviews/byproduct', // /{productId} will be appended
    UPDATE_STATUS: '/productreviews', // /{id}/status will be appended
  },
  
  // Cart Endpoints
  CART: {
    ADD: '/cart/add',
    GET: '/cart',
    UPDATE_QUANTITY: '/cart/updatequantity',
    REMOVE: '/cart',
    CLEAR: '/cart/clear',
    CHECKOUT: '/cart/checkout',
  },
  
  // Wishlist Endpoints
  WISHLIST: {
    ADD: '/Wishlist/add',
    GET: '/Wishlist',
    REMOVE: '/Wishlist/remove',
    CLEAR: '/Wishlist/clear',
  },
  
  // Product Enquiry Endpoints
  ENQUIRY: {
    SUBMIT: '/ProductEnquiry',
  },
  
  // Contact Endpoints
  CONTACT: {
    SUBMIT: '/Contacts',
  },
  
  // Geography Endpoints (Different base URL)
  GEO: {
    COUNTRIES: '/Countries',
    STATES: '/States/ByCountry',
    CITIES: '/Cities/ByState',
  },
  
  // Profile Endpoints
  PROFILE: {
    GET: '/profile',
    UPDATE: '/account/updateprofile',
  },
};

// HTTP Methods
export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE'
};

// Content Types
export const CONTENT_TYPES = {
  JSON: 'application/json',
  FORM_DATA: 'multipart/form-data'
};

// User Roles
export const USER_ROLES = {
  CUSTOMER: 'Customer',
  ADMIN: 'Admin'
};

// Gender Options
export const GENDER_OPTIONS = {
  MALE: 'Male',
  FEMALE: 'Female'
};